module.exports = __webpack_public_path__ + "k-lose.wav?8a4b0f5b6844d01a8add46f805625738";


//////////////////
// WEBPACK FOOTER
// ./src/assets/k-lose.wav
// module id = 15
// module chunks = 0